import component from '@/components/select/date-picker/date-picker'
export default {
  mapKey: 'dateTime',
  label: 'select.datePicker',
  formItem: {
    component,
    type: 'datetime',
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    format: 'yyyy-MM-dd HH:mm:ss'
  }
}
